import numeral from 'numeral';
import { numeralLocaleConfigDE } from './numeralLocales/de';
import { numeralLocaleConfigEnGb, numeralLocaleConfigEnUs } from './numeralLocales/en';
import { numeralLocaleConfigFr } from './numeralLocales/fr';
import { numeralLocaleConfigNlNl } from './numeralLocales/nl';
const FALLBACK_LANGUAGE = 'nl_NL';
const AsNumeral = (() => {
    const register = (locale, config) => {
        if (numeral.locales[locale.toLowerCase()] === undefined) {
            numeral.register('locale', locale, config);
        }
    };
    register('nl_NL', numeralLocaleConfigNlNl);
    register('fr_FR', numeralLocaleConfigFr);
    register('en_GB', numeralLocaleConfigEnGb);
    register('de_DE', numeralLocaleConfigDE);
    register('en_US', numeralLocaleConfigEnUs);
    numeral.locale(FALLBACK_LANGUAGE);
    return {
        register,
        changeLocal: (newLocale) => {
            numeral.locale(newLocale);
        },
        formatAsCurrency: (value) => {
            return numeral(value).format('0,0.00');
        },
    };
})();
export default AsNumeral;
